import { FC, useEffect } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import {
  TOOTH_INFORMATION,
  TOOTH_INFORMATION_OPTIONS
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import DentitionTypeWithToothCharts from './DentitionTypeWithToothCharts/DentitionTypeWithToothCharts';
import { FormLabel } from './FormLabel/FormLabel';
import RhfRadioGroup from './RadioGroup/RhfRadioGroup/RhfRadioGroup';
interface Props {
  fieldName: string;
  title: string;
  animateLabel: string;
  isDisabled?: boolean;
  isUpperDisabled?: boolean;
  isLowerDisabled?: boolean;
}
const ToothInformation: FC<Props> = ({
  fieldName,
  title,
  isDisabled,
  animateLabel,
  isUpperDisabled,
  isLowerDisabled
}) => {
  const {
    watch,
    trigger,
    formState: { errors, isSubmitted }
  } = useFormContext();
  const watchedFields = [
    `${fieldName}.information`,
    `${fieldName}.dentitionSelection`,
    `${fieldName}.toothChart`,
    `${fieldName}.primaryToothChart`
  ];
  const [
    watchToothInformationSelection,
    dentitionSelection,
    toothChart,
    primaryToothChart
  ] = watch(watchedFields);
  const fieldError = _.get(errors, fieldName);

  useEffect(() => {
    if (isSubmitted) trigger(watchedFields);
  }, [
    watchToothInformationSelection,
    dentitionSelection,
    toothChart,
    primaryToothChart,
    isSubmitted,
    trigger
  ]);

  return (
    <div className='flex flex-col'>
      <FormLabel
        label={translate(title)}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={animateLabel}
      />
      <div>
        <RhfRadioGroup
          inputProps={{ disabled: isDisabled }}
          options={TOOTH_INFORMATION_OPTIONS}
          name={`${fieldName}.information`}
          className='flex flex-row space-x-16'
          radioClassName='border-RADIO_BORDER'
          radioItemFont='md:text-17px text-sm'
        />
      </div>

      {watchToothInformationSelection === TOOTH_INFORMATION.MISSING_TEETH && (
        <div className='my-6 ml-5'>
          <DentitionTypeWithToothCharts
            dentitionSelectionName={`${fieldName}.dentitionSelection`}
            adultChartName={`${fieldName}.toothChart`}
            primaryChartName={`${fieldName}.primaryToothChart`}
            disabled={isDisabled}
            isUpperDisabled={isUpperDisabled}
            isLowerDisabled={isLowerDisabled}
          />
        </div>
      )}
    </div>
  );
};
export default ToothInformation;
